<template>
  <v-container v-if="contact" style="display: flex;cursor: pointer;" @click="openModal">
    <v-row class="pare" style="display: flex; font-size: .9em">
      <div class="truncate" style="line-height: 24px; width: 15%;">
        {{ oldCif }}
      </div>
      <div class="truncate col-2" style="line-height: 24px; width: 20%; margin-right:8%; text-align: center">
        {{ oldClient }}
      </div>
      <div class="col-2">
        <v-icon v-if="acceptByppay">
          mdi-checkbox-marked-circle
        </v-icon>
        <v-icon v-if="!acceptByppay">
          mdi-alert-circle
        </v-icon>
      </div>
      <div class="col-2">
        <v-icon v-if="correctCrypto">
          mdi-checkbox-marked-circle
        </v-icon>
        <v-icon v-if="!correctCrypto">
          mdi-alert-circle
        </v-icon>
      </div>
      <div class="col-2">
        <v-icon v-if="correctStripe">
          mdi-checkbox-marked-circle
        </v-icon>
        <v-icon v-if="!correctStripe">
          mdi-alert-circle
        </v-icon>
      </div>
      <div>
        <v-icon v-if="acceptBank">
          mdi-checkbox-marked-circle
        </v-icon>
        <v-icon v-if="!acceptBank">
          mdi-alert-circle
        </v-icon>
      </div>
    </v-row>
    <v-dialog
      ref="dialog"
      v-model="modalClient"
      width="320px"
    >
      <v-form v-model="valid" style="background-color: white;">
        <v-text-field
          v-model="client"
          :label="$t('Contact Name')"
          append-icon="mdi-account"
          style="margin-left: 20px; margin-right: 20px; width: 280px;"
          :rules="rules.name"
        />

        <v-text-field
          v-model="cif"
          :label="$t('Contact NIF/CIF')"
          append-icon="mdi-passport"
          style="margin-left: 20px; margin-right: 20px; width: 280px"
          :rules="rules.cif"
        />

        <v-text-field
          v-model="email"
          :label="$t('Contact Email')"
          append-icon="mdi-email"
          style="margin-left: 20px; margin-right: 20px; width: 280px"
          :rules="rules.email"
        />

        <v-text-field
          v-model="phone"
          :label="$t('Contact Phone')"
          append-icon="mdi-email"
          style="margin-left: 20px; margin-right: 20px; width: 280px"
          :rules="rules.phone"
        />
        <v-card-actions class="justify-center">
          <v-btn :disabled="!valid" style="margin-left: auto; margin-right: auto;" text color="#FF6961" @click="deleteContact()">
            {{ $t('DELETE') }}
          </v-btn>
          <v-btn :disabled="!valid" style="margin-left: auto; margin-right: auto;" text color="primary" @click="editContact()">
            {{ $t('EditContact.SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";

export default {
    name: "Contact",

    props: {
        contact: {type: Object, default: null},
    },
    data () {
        return {
            status: "",
            cif: "",
            client: "",
            email: "",
            phone: "",
            oldCif: "",
            oldClient: "",
            oldEmail: "",
            oldPhone: "",
            acceptByppay: false,
            correctCrypto: false,
            correctStripe: false,
            acceptBank: false,
            modalClient: null,
            rules: {
                name: [v => !!v || this.$t('A name is required'), ],
                value: [v => !!v || this.$t('The value field is required'), ],
                number: [v => !!v || this.$t('The phone field is required'), ],
                phone: [ v => (/^(\+?[\d ]{9,}|)$/.test(v) || v === "") || this.$t('The phone must be valid') ],
                email: [ v => (/.+@.+\..+/.test(v) || v === "") || this.$t('The mail must be valid.') ],
                cif: [
                    v => !!v || this.$t('A cif is required'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || v === '' || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)'),
                    v => v.toUpperCase() !== this.$user.cif.toUpperCase() || this.$t('Error.The CIF must be different than yours.')
                ],
            },
            valid: false
        };
    },
    created () {
        this.factoringStatus();
    },
    methods: {
        openModal(){
            this.factoringStatus();
            this.modalClient = true;
        },
        async factoringStatus () {
            this.client = this.oldClient = this.contact.name;
            this.cif = this.oldCif = this.contact.cif;
            this.email = this.oldEmail = this.contact.email;
            this.phone = this.oldPhone = this.contact.phone;
            this.correctStripe = (await ApiRepository.existUserStripe(this.cif)).data.exists;
            this.acceptBank = (await ApiRepository.acceptBank(this.cif)).data.acceptBank;
        },
        async deleteContact () {
            const contact = {
                cif: this.oldCif,
                name: this.oldClient,
                email: this.oldEmail,
                phone: this.oldPhone
            };
            await ApiRepository.deleteContact(this.$user.cif, contact).then((res) => {
                this.modalClient = false;
                this.$root.$emit('show-snackbar', {message: this.$t('Contact deleted successfully!'), color: "success"});
                this.$emit('fetch');
            });
        },
        async editContact () {
            const contact = {
                cif: this.cif,
                name: this.client,
                email: this.email,
                phone: this.phone,
                _id: this.contact._id
            };
            await ApiRepository.existContact(this.cif, contact).then(async (res) => {
                if (res.data.cif) {
                    this.$root.$emit('show-snackbar', {message: this.$t('CIF already in use!'), color: "error"});
                } else if (res.data.phone ) {
                    this.$root.$emit('show-snackbar', {message: this.$t('Phone already in use!'), color: "error"});
                } else if (res.data.email) {
                    this.$root.$emit('show-snackbar', {message: this.$t('Email already in use!'), color: "error"});
                } else {
                    await ApiRepository.editContact(this.$user.cif, contact, this.oldCif).then((res) => {
                        this.modalClient = false;
                        this.$root.$emit('show-snackbar', {message: this.$t('Contact edited successfully!'), color: "success"});
                        this.$emit('fetch');
                    });
                }
            });
        },
    },


};
</script>

<style scoped>
  .pare div { padding: 0; }
  .iconGreen{
    color:var(--v-success-base) !important;
  }
  .iconRed{
    color:var(--v-error-base) !important;
  }
  .truncate{
    overflow:hidden;
    white-space: nowrap !important;
    text-overflow: ellipsis;
    display: block;
  }
</style>
